// web-staking-estimator-frontend/src/utils/geometry.js
import * as webMercatorUtils from "@arcgis/core/geometry/support/webMercatorUtils";

// Convert Web Mercator (3857) or other projection to lat/lon (WGS84/4326)
export function toWGS84FromXY(x, y, wkid = 3857) {
  try {
    if (!Number.isFinite(x) || !Number.isFinite(y)) {
      return { lat: null, lon: null };
    }
    if ((wkid | 0) === 4326) return { lat: y, lon: x }; // Already WGS84
    
    const pt = { x, y, spatialReference: { wkid } };
    const g = webMercatorUtils.webMercatorToGeographic(pt);
    return { lat: g?.y ?? null, lon: g?.x ?? null };
  } catch {
    return { lat: null, lon: null };
  }
}

// Generate signature for estimate caching - if sig changes, need to re-compute estimate
export function computeSig(requestInfo, selectedPoint, serviceType) {
  const s = {
    serviceType,
    svc_phase: requestInfo?.svc_phase,
    svc_volts: requestInfo?.svc_volts,
    svc_amps: requestInfo?.svc_amps,
    svc_ohug: requestInfo?.svc_ohug,
    x: selectedPoint?.x,
    y: selectedPoint?.y,
    wkid: selectedPoint?.wkid,
  };
  return JSON.stringify(s);
}

/**
 * Strip the heavy map image data URL from an object copy
 * Used to avoid including large base64 images in certain operations
 * @param {object} obj - Object that may contain mapImageDataUrl
 * @returns {object} New object without mapImageDataUrl
 */
export function stripMapImage(obj) {
  if (!obj || typeof obj !== "object") return {};
  const { mapImageDataUrl, ...rest } = obj;
  return rest;
}
